import { useContext } from "react";
import { ComponentContext } from "../contexts/ComponentContext";
import { getAnimationDriver } from "../helpers/getAnimationDriver";
const useAnimationDriver = () => useContext(ComponentContext).animationDriver ?? getAnimationDriver();
export {
  useAnimationDriver
};
//# sourceMappingURL=useAnimationDriver.js.map
